import { render, staticRenderFns } from "./ColorPickerAtom.vue?vue&type=template&id=34707044&scoped=true"
import script from "./ColorPickerAtom.vue?vue&type=script&lang=js"
export * from "./ColorPickerAtom.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerAtom.vue?vue&type=style&index=0&id=34707044&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34707044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34707044')) {
      api.createRecord('34707044', component.options)
    } else {
      api.reload('34707044', component.options)
    }
    module.hot.accept("./ColorPickerAtom.vue?vue&type=template&id=34707044&scoped=true", function () {
      api.rerender('34707044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/atoms/ColorPickerAtom.vue"
export default component.exports